import DrugService from "@/core/api/drug/drug.service";

export default {
  methods: {
    async mounted_mx() {
      const favouritesResponse = await DrugService.getAllFavouritesInfo();
      const favouritesArray = [];
      Object.keys(favouritesResponse.data).forEach((key) => {
        favouritesArray.push(favouritesResponse.data[key]);
      });
      this.favourites = favouritesArray;
    },
    async clearFavourite() {
      this.isFavourite = false;
      this.drugOne = '';
      this.clearFavouriteChoices();
    },
    async clearFavouriteChoices() {
      // this.editDrug = false;
      this.drug2_id = false;
      this.drug2_maxdose_uom = false;
      this.drug2_name = false;
      this.hasDrugTwo = false;
      this.displaySecondDrug = false;
      this.drug1_maxdose = false;
      this.drug1_maxdose_uom = false;
      this.drug1_dose_uom = false;
      this.adminRouteCode = false;
      this.adminRoutes = [];
      this.containerTypes = [];
      this.containerDescriptions = [];
      this.containerTypeId = false;
      this.containerId = false;
      this.diluent_id = false;
      this.diluentExactFinalVolume = false;
      this.ancillary1Id = false;
      this.ancillary2Id = false;
      this.addingFpDrug = false;
      this.containerPartCode = false;
      this.infusionTime = "";
    },
    async onFavouriteChange(f) {
      this.drug1_stability_data = false;
      if (!f) {
        // x button clicked
        this.clearFavourite();
        this.drugOne = {}
      } else {
        this.clearFavouriteChoices();
        const favouriteChosen = f.name;
        let favChosen = false;
        this.favourites.forEach((favourite) => {
          if (favourite.name === favouriteChosen) {
            favChosen = favourite;
          }
        });
        if (favChosen) {
          this.drugs.forEach((drug) => {
            if (drug.title === favChosen.drug_name) {
              // this is the drug
              this.drugOne = drug;
              this.drugOne.type = "PS";
            }
          });
          this.populatingFavourite_drugOne = true;
          this.isFavourite = true;

          this.drug1_name = favChosen.drug_name;

          if (favChosen.drug2_id) {
            // this.editDrug.drug2_id = favChosen.drug2_id;
            this.drug2_id = favChosen.drug2_id;
            this.drug2_maxdose_uom = favChosen.drug2_maxdose_uom;
            this.drug2_name = favChosen.drug2_name;
            this.hasDrugTwo = true;
            this.displaySecondDrug = true;
          }

          this.populatingFavourite_drug1_name = true;
          this.getDrugOnePresentation();

          this.drug1_maxdose = this.round_2(favChosen.drug1_maxdose);
          this.drug1_dose = favChosen.drug1_dose;
          this.drug1_maxdose_uom = favChosen.drug1_maxdose_uom;
          this.drug1_dose_uom = favChosen.drug1_maxdose_uom;

          // this.drug1_stability = drugInfo.stability;
          // this.drug1_allow_maxdose = drugInfo.drug1Dose;

          this.adminRouteCode = favChosen.admin_route;
          this.populatingFavourite_adminRouteCode = true;

          const data = {
            drug1_name: favChosen.drug_name,
            drug1Dose: favChosen.drug1_dose,
            drug1_maxdose_uom: this.drug1_maxdose_uom,
            admin_route_code: this.adminRouteCode,
            type: "PS",
          };

          if (this.displaySecondDrug && this.drug2_id !== "") {
            data.drug2_id = this.drug2_id;
            data.drug2_maxdose_uom = this.drug2_maxdose_uom;
          }

          const m = await DrugService.basicDrugInfo(data);
          this.adminRoutes = m.data.admin_route_options;
          this.containerTypes = m.data.container_options;
          this.containerDescriptions = m.data.container_description_options;
          this.containerTypeId = favChosen.containertype_id;
          this.populatingFavourite_containerTypeId = true;

          this.containerId = favChosen.container_part_code;
          this.populatingFavourite_containerId = true;

          this.getDiluents();
          let hasDiluent = false;

          if (favChosen.diluent_id && favChosen.diluent_id !== "0") {
            this.diluent_id = favChosen.diluent_id;
            this.populatingFavourite_diluent_id = true;
            hasDiluent = true;
          }

          if (favChosen.container_part_code) {
            this.containerPartCode = favChosen.container_part_code;
          }

          // if (favChosen.diluent_volume) {
          //   this.diluentVolume = this.round_2(favChosen.diluent_volume);
          //   this.diluentExactFinalVolume = true;
          // } else {
          //   this.diluentExactFinalVolume = false;
          //   this.setDefaultDiluentVolume();
          // }
          // Always use default volume

          switch (this.containerTypes[this.containerTypeId]) {
            case "Syringe":
            case "Empty Bag":
            case "Reservoir":
              this.diluentExactFinalVolume = hasDiluent;
              break;
            default:
              this.diluentExactFinalVolume = false;
              break;
          }

          this.setDefaultDiluentVolume();

          await this.getAncillaries();

          if (favChosen.ancillary1_id && favChosen.ancillary1_id !== "0") {
            this.ancillary1Id = favChosen.ancillary1_id.toString();
          }
          if (favChosen.ancillary2_id && favChosen.ancillary2_id !== "0") {
            this.ancillary2Id = favChosen.ancillary2_id.toString();
            this.showSecondAncillary = true;
          }
          if (favChosen.infusionTime) {
            this.infusionTime = favChosen.infusionTime;
          } else {
            this.infusionTime = "";
          }
          this.populatingFavourite_infusionTime = true;

          this.addingFpDrug = false;
        }
      }
    },
    drugOne_mx(val) {
      if (!val) {
        this.deleteDrugOne();
      } else {
        if (val.finish_product_code === val.title) {
          // User has selected a product code - change it to the title

          this.drugs.forEach((drug) => {
            if (drug.type === "FP") {
              if (
                drug.finish_product_code === val.finish_product_code && drug.title !== val.finish_product_code
              ) {
                // this is the drug
                this.drugOne = drug;
              }
            }
          });
        }
        this.drug1_name = "";
        this.drug1_dose = "";
        this.drug1_dose_uom = "";
        this.drug1_uoms = [];

        // fp drug
        this.drug1_stability = "";
        this.drug1_product_code = "";

        // second drug
        this.displaySecondDrug = false;
        this.hasDrugTwo = false;
        this.drug2Options = [];
        this.drug2_dose = "";
        this.drug2_maxdose = "";
        this.drug2_maxdose_uom = "";
        this.drug2_uoms = [];
        this.drug2_id = "";
        this.drug2_dose = "";

        this.isDiluentOptional = false;
        this.containerPartCode = false;
        this.diluent_id = "";
        this.diluents = [];
        this.infusionTime = "";
        this.containerId = "";
        this.containerDescriptions = [];
        this.containerTypeId = "";
        this.containerTypes = [];

        this.adminRoutes = [];
        this.adminRouteCode = "";

        if (typeof val.title !== "undefined") {
          this.onDrugOneSelect();
        }
      }
    },
    refreshPresentations_mx(data) {
      if (data.drug1) {
        if (data.drug1.drug1_maxdose) {
          this.drug1_maxdose = data.drug1.drug1_maxdose;
        }
      }
      if (data.drug2) {
        if (data.drug2.drug2_maxdose) {
          this.drug2_maxdose = data.drug2.drug2_maxdose;
        }
      }
    },
    waiting_on() {
      document.body.classList.add("waiting");
    },
    waiting_off() {
      document.body.classList.remove("waiting");
    },
  },
};
